import React, {useEffect, useState} from "react";
import {useOrganization} from "../../../../hooks/useOrganization";
import DataGrid from "../../../General/DataGrid/DataGrid";
import {AlertWu} from "../../../AlertWu/AlertWu";
import service from "../../../../service/service";
import {Button} from "@material-ui/core";
import {AddAccountCategory} from "./AddAccountCategory";

let accountColumn = [
    {field: "AccountId", headerName: "Account Id", resizable: true, sortable: true},
    {field: "AccountAlias", resizable: true, sortable: true},
    {field: "AccountCategory", resizable: true, sortable: true},
    {field: "AccountName", resizable: true, sortable: true},

]

export default function AccountCategorySetting() {
    const organization = useOrganization()
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [accountList, setAccountList] = useState([]);
    const [newAccountCategory, setNewAccountCategory] = useState(false);

    const [error, setError] = useState({
        error: false,
        errorMessage: ""
    })

    useEffect(() => {
        if (organization.organization !== "no org") {
            setLoading(true);
            setReady(false);
            const param = {master_id: organization.organization}
            service.general().getAccountInformationByMasterId(param)
                .then((ref) => {
                    let data = ref.data.account;
                    setAccountList(data);
                    setLoading(false);
                    setReady(true);
                })
                .catch((err) => {
                    setLoading(false);
                    setError({error: true, errorMessage: err.message})
                })
        }
    }, [organization.organization])

    return (
        <div>
            <div className="account-setting-list">
                {
                    !loading ?
                        <div className="onboarding-grid-wrapper">
                            <DataGrid
                                fileName={`accounts - ${organization.organization}`}
                                fixedColumn={accountColumn}
                                gridStyle={newAccountCategory ? {height: "calc(100vh - 550px)"} : {height: "calc(100vh - 350px)"}}
                                gridData={accountList}
                                gridClass="onboarding-grid"/></div> : "loading..."

                }

            </div>

            <AlertWu
                alertOpen={{state: error.error}}
                severity={"error"}
                message={error.message}/>

            <Button variant={"contained"} style={{marginTop: 20}} disableElevation
                    onClick={() => setNewAccountCategory(true)}
                    color={"primary"}>
                New Account Category
            </Button>

            {
                newAccountCategory &&
                <AddAccountCategory/>
            }

        </div>
    )
}